import { Environment } from './environment.model';

export const environment: Environment = {
  apim: {
    subscriptionKey: 'ad8b33aed1324eed9adff934f0efc676'
  },
  auth: {
    applicationId: '40506807-cd91-4c49-a362-b556b911e934',
    authorityUrl:
      'https://login.microsoftonline.com/fcb6fca8-f3c7-458b-9a80-211f5ce84b61/oauth2/v2.0/authorize',
    redirectUrl: 'https://observability-dev.agvantis.com/auth/callback'
  },
  observabilityService: {
    scope: 'api://2f8f3d1f-5b4e-44a8-959f-05012c194f64/Access',
    url: 'https://agv-apim-edt-c.azure-api.net/observabilityservice-dev/api/',
    version: 'v1'
  },
  production: false
};
